import { Box, BoxProps, Stack } from '@mantine/core'

import InfoCard from 'components/molecules/infoCard'
import useStyles from './index.styles'
import { ContentBanner } from 'interfaces/types'
import { CarouselOrListingBlock } from 'components/molecules/carouselOrListingBlock'
import { useIsMobile } from 'hooks/useIsMobile'

type Props = {
  isSingleLayout?: boolean
  data: ContentBanner[]
} & BoxProps
export const AppIntroCards = ({
  data = [],
  isSingleLayout,
  ...rest
}: Props) => {
  const { classes, theme } = useStyles(undefined, {
    name: 'AppIntroCards',
  })
  const isMobile = useIsMobile()
  return isSingleLayout || data.length === 1 ? (
    <Stack spacing={24} {...rest}>
      {data.map((i, idx) => (
        <InfoCard.WideLayout
          key={idx}
          thumbnail={i.banner}
          {...i}
          sx={() => ({
            position: 'sticky',
            top: 36 + (idx + 1) * 20,
            [theme.fn.largerThan('sm')]: {
              top: 110 + (idx + 1) * 20,
            },
          })}
        />
      ))}
    </Stack>
  ) : (
    <Box {...rest}>
      <CarouselOrListingBlock
        showFullSlide={!isMobile}
        disableCarousel={isMobile}
        lengthToCarouselDesktop={4}
        lengthToCarouselMobile={2}
        // percentOfEndSlideMobile={88}
        lazyLoad
        // onSlideChange={onSlideChange}
        carouselSetting={{
          loop: false,
        }}
      >
        <CarouselOrListingBlock.Slider
          styles={(theme) => ({
            listing: {
              [theme.fn.smallerThan('sm')]: {
                flexDirection: 'column',
              },
            },
          })}
        >
          {data.map((i, idx) => (
            <InfoCard.VerticalLayout
              key={idx}
              className={classes.item}
              ratio={data.length === 2 ? 660 / 400 : undefined}
              {...i}
              thumbnail={i.banner}
            />
          ))}
        </CarouselOrListingBlock.Slider>
      </CarouselOrListingBlock>
    </Box>

    // <Grid gutterSm={16} gutterMd={24} grow {...rest}>
    //   {data.map((i, idx) => (
    //     <Grid.Col
    //       key={idx}
    //       sm={1}
    //       md={4}
    //       sx={(theme) => ({
    //         [theme.fn.smallerThan('sm')]: {
    //           paddingLeft: 0,
    //           paddingRight: 0,
    //         },
    //       })}
    //     >
    //       <InfoCard.VerticalLayout
    //         className={classes.item}
    //         ratio={data.length === 2 ? 660 / 400 : undefined}
    //         {...i}
    //         thumbnail={i.banner}
    //       />
    //     </Grid.Col>
    //   ))}
    // </Grid>
  )
}
